<template>
  <div>
    <h5>درخواست ها</h5>
    <b-card
        v-if="tableData"
        no-body
        class="card-company-table"
    >
      <b-table
          :items="tableData"
          responsive
          :fields="fields"
          class="mb-0"
      >
        <!-- company -->
        <template #cell(title)="data">
          <div class="d-flex align-items-center cursor-pointer" @click="goToRequest(data.item.id)">
            {{ data.item.title }}
          </div>
        </template>
        <template #cell(creator)="data">
          {{ data.value.name }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BAvatar, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BImg,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fields: [
        { key: 'title', label: 'عنوان' },
        { key: 'creator', label: 'درخواست دهنده' },
        { key: 'created_at', label: 'تاریخ ایجاد' },
      ],
    }
  },
  methods:{
    goToRequest(requestId){
      this.$router.push(`requests/${requestId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
